/* NEX product cards: swipe carousel dots, colour dots (own colours by name), colour -> photo on cards, picker and product page */
(function () {
  'use strict';
  /* colour names -> real colours; longest/most specific first */
  var MAP = [['darkgrey', '#4a4a4f'], ['lightgrey', '#cfcfd4'], ['darkblue', '#1c2a5a'], ['lightblue', '#8cc8f5'], ['darkgreen', '#1f5a34'], ['lightgreen', '#a8e6c6'], ['offwhite', '#f4efe6'], ['burgundy', '#7a1530'], ['maroon', '#6e1630'], ['mustard', '#d9a21b'], ['charcoal', '#3a3a3a'], ['lavender', '#b9a0f0'], ['violet', '#7a3fd0'], ['purple', '#7a3fd0'], ['lilac', '#c4a0f0'], ['pink', '#f28bb8'], ['navy', '#1c2a5a'], ['blue', '#2f6fdb'], ['sky', '#8cc8f5'], ['teal', '#1a8a8a'], ['mint', '#a8e6c6'], ['green', '#2f9a4f'], ['olive', '#6b6b2e'], ['khaki', '#a89a6a'], ['beige', '#d9c3a0'], ['sand', '#d8c39a'], ['cream', '#f3ead3'], ['brown', '#6b4428'], ['tan', '#c9a977'], ['coffee', '#6b4428'], ['yellow', '#f5d530'], ['gold', '#d4a72c'], ['orange', '#f28a1d'], ['coral', '#f26b5b'], ['red', '#d92b2b'], ['black', '#151515'], ['white', '#ffffff'], ['silver', '#c9c9c9'], ['ice', '#cfe9ff'], ['grey', '#9a9a9a']];
  function norm(s) { return String(s || '').toLowerCase().replace(/gray/g, 'grey').replace(/[^a-z]/g, ''); }
  function colorOf(name) { var n = norm(name); for (var i = 0; i < MAP.length; i++) if (n.indexOf(MAP[i][0]) > -1) return MAP[i][1]; return ''; }
  function ink(hex) { var r = parseInt(hex.substr(1, 2), 16), g = parseInt(hex.substr(3, 2), 16), b = parseInt(hex.substr(5, 2), 16); return (r * 299 + g * 587 + b * 114) / 1000 > 150 ? '#2e1065' : '#ffffff'; }
  /* colour synonyms used to find a colour's photo by file name / alt text */
  var SYN = { burgundy: ['burgundy', 'burghandy', 'bordeaux', 'wine', 'maroon'], mustard: ['mustard', 'tan', 'yellow', 'gold'], purple: ['purple', 'violet', 'lilac', 'lavender'], pink: ['pink'], blue: ['blue', 'navy'] };
  function photoIndex(scope, name, sel) {
    var n = norm(name), slides = scope.querySelectorAll(sel || '.card__slide img'), keys = [n], out = -1;
    Object.keys(SYN).forEach(function (k) { if (n.indexOf(k) > -1) keys = SYN[k]; });
    var texts = [].map.call(slides, function (im) {
      var f = ''; try { f = decodeURIComponent((im.getAttribute('src') || '').split('?')[0].split('/').pop()); } catch (e) {}
      return norm(f + ' ' + (im.getAttribute('alt') || ''));
    });
    keys.forEach(function (k) { if (out < 0) texts.forEach(function (t, i) { if (out < 0 && t.indexOf(k) > -1) out = i; }); });
    if (out < 0 && n === 'lightgrey') texts.forEach(function (t, i) { if (out < 0 && t.indexOf('grey') > -1 && t.indexOf('darkgrey') < 0) out = i; });
    return out;
  }
  function swap(img, url) {
    if (!img || !url) return;
    var pre = new Image();
    img.style.transition = 'opacity .18s'; img.style.opacity = '.35';
    pre.onload = pre.onerror = function () { img.removeAttribute('srcset'); img.src = url; img.style.opacity = '1'; };
    pre.src = url;
  }
  function home(scope) { var t = scope.querySelector && scope.querySelector('[data-track]'); if (t) t.scrollTo({ left: 0, behavior: 'smooth' }); }
  /* paint every colour control with its own colour */
  function paint(root) {
    if (!root.querySelectorAll) return;
    [].forEach.call(root.querySelectorAll('.sw__dot[data-name]'), function (d) { if (!d.style.background && !d.style.backgroundColor) { var c = colorOf(d.getAttribute('data-name')); if (c) d.style.background = c; } });
    [].forEach.call(root.querySelectorAll('.ro__dot[data-c]'), function (d) { var c = colorOf(d.getAttribute('data-c')); if (c) { d.style.background = c; } });
    [].forEach.call(root.querySelectorAll('fieldset.opt'), function (f) {
      var lg = f.querySelector('legend'); if (!lg || !/colou?r/i.test(lg.textContent)) return;
      [].forEach.call(f.querySelectorAll('label.opt__chip:not(.opt__chip--swatch)'), function (l) {
        var c = colorOf((l.querySelector('span') || l).textContent); if (!c) return;
        l.classList.add('opt__chip--swatch'); l.style.setProperty('--sw', c); l.style.setProperty('--sw-ink', ink(c));
      });
    });
  }
  /* dots follow the swipe */
  function mark(t) {
    var d = t.parentNode.querySelector('[data-cdots]'); if (!d) return;
    var n = t.children.length;
    if (d.children.length !== n) { d.innerHTML = ''; for (var i = 0; i < n; i++) d.appendChild(document.createElement('i')); }
    var k = Math.max(0, Math.min(n - 1, Math.round(t.scrollLeft / (t.clientWidth || 1))));
    [].forEach.call(d.children, function (x, i) { x.classList.toggle('is-on', i === k); });
  }
  document.addEventListener('scroll', function (e) { var t = e.target; if (t && t.matches && t.matches('[data-track]')) mark(t); }, { capture: true, passive: true });
  function init(root) { [].forEach.call((root || document).querySelectorAll('[data-track]'), mark); paint(root || document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  new MutationObserver(function (ms) { ms.forEach(function (m) { [].forEach.call(m.addedNodes, function (n) { if (n.nodeType === 1) init(n); }); }); }).observe(document.documentElement, { childList: true, subtree: true });
  /* mouse: hover peeks the next photo */
  if (window.matchMedia && window.matchMedia('(hover:hover)').matches) {
    document.addEventListener('mouseover', function (e) {
      var m = e.target.closest && e.target.closest('.card__media'); if (!m || m.__hv) return;
      var t = m.querySelector('[data-track]'); if (!t || t.children.length < 2) return;
      m.__hv = 1; t.scrollTo({ left: t.clientWidth, behavior: 'smooth' });
      m.addEventListener('mouseleave', function () { m.__hv = 0; t.scrollTo({ left: 0, behavior: 'smooth' }); }, { once: true });
    });
  }
  function goTo(card, i) { var t = card.querySelector('[data-track]'); if (t && i > -1) t.scrollTo({ left: i * t.clientWidth, behavior: 'smooth' }); }
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t.closest) return;
    var dot = t.closest('.qa .ro__dot');
    if (dot) {
      var q = dot.closest('.qa'), host = q.parentNode, card = host.closest('.card') || host;
      setTimeout(function () {
        var src = q.querySelector('.rc__img img');
        var url = src && src.getAttribute('src');
        if (url && url !== q.__u) {
          q.__u = url;
          url = url.replace(/_\d+x(\.[a-z]+)(\?|$)/i, '_700x$1$2');
          var imgs = [].filter.call(host.querySelectorAll('img'), function (i) { return !q.contains(i); });
          swap(imgs[0], url); home(host); return;
        }
        var i = photoIndex(card, dot.getAttribute('data-c')); if (i > -1) goTo(card, i);
      }, 0);
      return;
    }
    var b = t.closest('[data-sw]');
    if (!b) return;
    e.preventDefault(); e.stopPropagation();
    var c = b.closest('.card'); if (!c) return;
    var u = b.getAttribute('data-img');
    [].forEach.call(c.querySelectorAll('[data-sw]'), function (x) { x.classList.toggle('is-on', x === b); x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
    if (u) { swap(c.querySelector('.card__img'), u); home(c); return; }
    var k = photoIndex(c, b.getAttribute('data-name')); if (k > -1) goTo(c, k);
  }, true);
  /* product page: a colour with no linked photo -> find its photo by file name / alt and bring it first */
  document.addEventListener('change', function (e) {
    var form = e.target.closest && e.target.closest('[data-product-form]'); if (!form) return;
    var fs = e.target.closest('fieldset.opt'), lg = fs && fs.querySelector('legend');
    if (!lg || !/colou?r/i.test(lg.textContent)) return;
    var name = e.target.value;
    setTimeout(function () {
      var root = document.querySelector('[data-product]'), g = root && root.querySelector('[data-gallery]'), J = root && root.querySelector('[data-variants]');
      if (!g || !J) return;
      try {
        var vs = JSON.parse(J.textContent), o = [].map.call(form.querySelectorAll('fieldset.opt'), function (f) { var c = f.querySelector('input:checked'); return c ? c.value : null; });
        var v = vs.filter(function (x) { return x.options.every(function (t, i) { return t === o[i]; }); })[0];
        if (v && v.media) return;
      } catch (er) { return; }
      var i = photoIndex(g, name, 'figure img'); if (i < 0) return;
      var fig = g.querySelectorAll('figure')[i]; if (!fig || fig === g.firstElementChild) return;
      g.insertBefore(fig, g.firstChild); fig.classList.add('is-in');
      if (window.matchMedia('(max-width:860px)').matches) g.scrollTo({ left: 0, behavior: 'smooth' });
      var r = g.getBoundingClientRect();
      if (r.top < -20 || r.top > window.innerHeight * .6) window.scrollTo({ top: window.scrollY + r.top - 90, behavior: 'smooth' });
    }, 80);
  });
})();
